// extracted by mini-css-extract-plugin
export default {"root":"Option_root__FlPuB","remove":"Option_remove__IDmO4","body":"Option_body__cWFTc","clickable":"Option_clickable__Z3d4u"};